/**
 * Blog post registry. Each post is defined here with metadata.
 * Content is loaded from translation files: public/locales/{lang}/blog-{slug}.json
 */

export const blogPosts = [
  {
    slug: "track-field-employees-without-spying",
    category: "privacy",
    date: "2026-03-07",
    readTime: 8,
    image: "/TrackTeam/blog/privacy-tracking.jpg",
    keyword: "best app to track field employees without spying",
  },
  {
    slug: "privacy-friendly-gps-tracking-field-teams",
    category: "privacy",
    date: "2026-03-07",
    readTime: 7,
    image: "/TrackTeam/blog/privacy-gps.jpg",
    keyword: "privacy-friendly employee gps tracking",
  },
  {
    slug: "gps-expense-tracking-field-teams",
    category: "features",
    date: "2026-03-07",
    readTime: 6,
    image: "/TrackTeam/blog/expense-gps.jpg",
    keyword: "employee expense tracking with GPS",
  },
  {
    slug: "automate-field-team-payroll",
    category: "features",
    date: "2026-03-07",
    readTime: 7,
    image: "/TrackTeam/blog/payroll-automation.jpg",
    keyword: "automated field team payroll tracking",
  },
  {
    slug: "track-delivery-drivers-real-time",
    category: "industry",
    date: "2026-03-07",
    readTime: 8,
    image: "/TrackTeam/blog/delivery-tracking.jpg",
    keyword: "how to track delivery drivers in real time",
  },
  {
    slug: "construction-crew-attendance-gps",
    category: "industry",
    date: "2026-03-07",
    readTime: 7,
    image: "/TrackTeam/blog/construction-attendance.jpg",
    keyword: "construction crew attendance tracking app",
  },
  {
    slug: "verify-field-technician-visits",
    category: "howto",
    date: "2026-03-07",
    readTime: 6,
    image: "/TrackTeam/blog/technician-visits.jpg",
    keyword: "field technician visit verification",
  },
  {
    slug: "signs-field-team-needs-gps-tracking",
    category: "howto",
    date: "2026-03-07",
    readTime: 7,
    image: "/TrackTeam/blog/gps-signs.jpg",
    keyword: "field team gps tracking app",
  },
  {
    slug: "hubstaff-vs-trackteam-field-teams",
    category: "comparison",
    date: "2026-03-07",
    readTime: 9,
    image: "/TrackTeam/blog/vs-hubstaff.jpg",
    keyword: "alternative to hubstaff for field teams",
  },
  {
    slug: "connecteam-alternative-small-teams",
    category: "comparison",
    date: "2026-03-07",
    readTime: 8,
    image: "/TrackTeam/blog/vs-connecteam.jpg",
    keyword: "connecteam alternative for small teams",
  },
];

export const blogCategories = [
  { key: "all", label: "all" },
  { key: "privacy", label: "privacy" },
  { key: "features", label: "features" },
  { key: "industry", label: "industry" },
  { key: "howto", label: "howTo" },
  { key: "comparison", label: "comparison" },
];

export function getBlogPostBySlug(slug) {
  return blogPosts.find((p) => p.slug === slug);
}

export function getBlogPostsByCategory(category) {
  if (!category || category === "all") return blogPosts;
  return blogPosts.filter((p) => p.category === category);
}
